const UserAreaTestData = {
  company: 'Тест (заполнить нужной информацией)',
  location: 'Тест (заполнить нужной информацией)',
  pilotStatus: false,
  pilotStatusExpirationDate: '01.02.2024'
};

export default UserAreaTestData;
